import React, { lazy, createElement, Suspense } from 'react'
import type { IMenuList } from './type'
import * as httpSettings from '@/config/httpSettings'
import {
  CreditCardOutlined,
  LineChartOutlined,
  NodeIndexOutlined,
  ScheduleOutlined,
  SettingOutlined,
  CloudOutlined,
  BarChartOutlined,
  HistoryOutlined
  // QuestionCircleOutlined
} from '@ant-design/icons'
import { Spin } from 'antd'
// import { Spin, Tooltip } from 'antd'

const createLazyElement = (ele: () => Promise<{ default: React.FC }>) => {
  return (
    <Suspense
      fallback={
        <Spin
          size="large"
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh'
          }}
        />
      }
    >
      {createElement(lazy(ele))}
    </Suspense>
  )
}

const createLazyElementWithProps = (ele: () => Promise<{ default: React.ComponentType<any> }>, props: any) => {
  const LazyComponent = lazy(ele)
  return (
    <Suspense
      fallback={
        <Spin
          size="large"
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh'
          }}
        />
      }
    >
      {createElement(LazyComponent, props)}
    </Suspense>
  )
}

export const menuList: IMenuList[] = [
  {
    index: true,
    layout: false,
    menu: false,
    id: 'login',
    path: httpSettings.loginUrl.startsWith('/') ? httpSettings.loginUrl.slice(1) : httpSettings.loginUrl,
    element: createLazyElement(async () => await import('@/pages/Login')),
    name: 'login'
  },
  {
    layout: false,
    menu: false,
    id: 'trial',
    path: '/user/trial',
    element: createLazyElement(async () => await import('@/pages/Trial')),
    name: 'trial'
  },
  {
    layout: false,
    menu: false,
    id: 'trialSuccess',
    path: '/user/trialSuccess',
    element: createLazyElement(async () => await import('@/pages/TrialSuccess')),
    name: 'trialSuccess'
  },
  {
    id: 'bankCardSourceData',
    path: 'bankCardSourceData',
    name: '卡证数据源',
    icon: <CreditCardOutlined />
  },
  {
    id: 'highRiskBankCard',
    path: 'highRiskBankCard',
    parentId: 'bankCardSourceData',
    element: createLazyElement(async () => await import('@/pages/HighRiskBankCard')),
    name: '高危卡号',
    // icon: <AppstoreOutlined />,
    breadCrumb: [
      {
        title: '卡证数据源 / 高危卡号',
        href: `${BASE_PATH}/highRiskBankCard`
      }
    ]
  },
  {
    id: 'bankcardOriginalMessage',
    path: 'highRiskBankCard/message',
    menu: false,
    element: createLazyElement(async () => await import('@/pages/HighRiskBankCard/message')),
    name: '原始消息'
  },
  {
    id: 'highRiskIdentityCards',
    path: 'highRiskIdentityCards',
    parentId: 'bankCardSourceData',
    element: createLazyElement(async () => await import('@/pages/HighRiskIdentityCards')),
    name: '高危身份证',
    // icon: <SettingOutlined />,
    breadCrumb: [
      // {
      //   title: '银行卡源数据',
      //   href: `${BASE_PATH}/bankCardSourceData`
      // },
      {
        title: '卡证数据源 / 高危身份证',
        href: `${BASE_PATH}/highRiskIdentityCards`
      }
    ]
  },
  {
    id: 'idcardOriginalMessage',
    path: 'highRiskIdentityCards/message',
    menu: false,
    element: createLazyElement(async () => await import('@/pages/HighRiskIdentityCards/message')),
    name: '原始消息'
  },
  // {
  //   id: 'accountDetails',
  //   path: 'accountDetails',
  //   parentId: 'bankCardSourceData',
  //   element: createLazyElement(async () => await import('@/pages/AccountDetails')),
  //   name: '账户详情信息',
  //   // icon: <SettingOutlined />,
  //   breadCrumb: [
  //     // {
  //     //   title: '银行卡源数据',
  //     //   href: `${BASE_PATH}/accountDetails`
  //     // },
  //     {
  //       title: '卡证数据源 / 账户详情信息',
  //       href: `${BASE_PATH}/highRiskIdentityCards`
  //     }
  //   ]
  // },
  {
    id: 'transferReceiptInformation',
    path: 'transferReceiptInformation',
    parentId: 'bankCardSourceData',
    element: createLazyElement(async () => await import('@/pages/TransferReceiptInformation')),
    name: '转账详情',
    // icon: <SettingOutlined />,
    breadCrumb: [
      // {
      //   title: '银行卡源数据',
      //   href: `${BASE_PATH}/transferReceiptInformation`
      // },
      {
        title: '卡证数据源 / 转账详情',
        href: `${BASE_PATH}/highRiskIdentityCards`
      }
    ]
  },
  {
    id: 'transferreceiptOriginalMessage',
    path: 'transferReceiptInformation/message',
    menu: false,
    element: createLazyElement(async () => await import('@/pages/TransferReceiptInformation/message')),
    name: '原始消息'
  },
  {
    id: 'trendAnalysis',
    path: 'trendAnalysis',
    name: '趋势分析',
    icon: <LineChartOutlined />
  },
  {
    id: 'supplyTrend',
    path: 'supplyTrend',
    parentId: 'trendAnalysis',
    element: createLazyElement(async () => await import('@/pages/SupplyTrend')),
    name: '供数趋势',
    // icon: <SettingOutlined />,
    breadCrumb: [
      // {
      //   title: '趋势分析',
      //   href: `${BASE_PATH}/trendAnalysis`
      // },
      {
        title: '趋势分析 / 供数趋势',
        href: `${BASE_PATH}/supplyTrend`
      }
    ]
  },
  {
    id: 'bankCardActivityField',
    path: 'bankCardActivityField',
    parentId: 'trendAnalysis',
    element: createLazyElement(async () => await import('@/pages/BankCardActivityField')),
    name: '银行活跃指数',
    // icon: <SettingOutlined />,
    breadCrumb: [
      // {
      //   title: '趋势分析',
      //   href: `${BASE_PATH}/trendAnalysis`
      // },
      {
        title: '趋势分析 / 银行活跃指数',
        href: `${BASE_PATH}/bankCardActivityField`
      }
    ]
  },
  {
    id: 'hotWord',
    path: 'hotWord',
    element: createLazyElement(async () => await import('@/pages/HotWord')),
    name: '热词云图',
    icon: <CloudOutlined />,
    breadCrumb: [
      {
        title: '热词云图',
        href: `${BASE_PATH}/hotWord`
      }
    ]
  },
  {
    id: 'bankPriceTrend',
    path: 'bankPriceTrend',
    name: '银行卡价格趋势',
    icon: <BarChartOutlined />
  },
  {
    id: 'currBankPriceTrend',
    path: 'currBankPriceTrend',
    parentId: 'bankPriceTrend',
    element: createLazyElement(async () => await import('@/pages/CurrBankPriceTrend')),
    name: '本行价格动态',
    breadCrumb: [
      {
        title: '银行卡价格趋势 / 本行价格动态',
        href: `${BASE_PATH}/currBankPriceTrend`
      }
    ]
  },
  {
    id: 'marketPriceOverview',
    path: 'marketPriceOverview',
    parentId: 'bankPriceTrend',
    element: createLazyElement(async () => await import('@/pages/MarketPriceOverview')),
    name: '市场价格总览',
    breadCrumb: [
      {
        title: '银行卡价格趋势 / 市场价格总览',
        href: `${BASE_PATH}/marketPriceOverview`
      }
    ]
  },
  {
    id: 'intelligenceLeads',
    path: 'intelligenceLeads',
    // element: createLazyElement(async () => await import('@/pages/IntelligenceLeads/new')),
    name: '情报线索',
    icon: <NodeIndexOutlined />
    // breadCrumb: [
    //   {
    //     title: '情报线索',
    //     href: `${BASE_PATH}/intelligenceLeads`
    //   }
    // ]
  },
  {
    id: 'attackIntelligence',
    path: 'attackIntelligence',
    parentId: 'intelligenceLeads',
    element: createLazyElement(async () => await import('@/pages/AttackIntelligence')),
    name: '攻击情报',
    breadCrumb: [
      {
        title: '情报线索 / 攻击情报',
        href: `${BASE_PATH}/attackIntelligence`
      }
    ]
  },
  {
    id: 'industryThinkTank',
    path: 'industryThinkTank',
    parentId: 'intelligenceLeads',
    element: createLazyElement(async () => await import('@/pages/IndustryThinkTank')),
    name: '行业智库',
    breadCrumb: [
      {
        title: '情报线索 / 行业智库',
        href: `${BASE_PATH}/industryThinkTank`
      }
    ]
  },
  {
    id: 'insight',
    path: 'insight',
    parentId: 'intelligenceLeads',
    element: createLazyElement(async () => await import('@/pages/Insight')),
    name: '洞见',
    breadCrumb: [
      {
        title: '情报线索 / 洞见',
        href: `${BASE_PATH}/insight`
      }
    ]
  },

  {
    id: 'informationConfiguration',
    path: 'informationConfiguration',
    name: '信息配置',
    icon: <SettingOutlined />
  },
  {
    id: 'bankCardIssuance',
    path: 'bankCardIssuance',
    parentId: 'informationConfiguration',
    element: createLazyElement(async () => await import('@/pages/BankCardIssuance')),
    name: '银行发卡量配置',
    breadCrumb: [
      // {
      //   title: '信息配置',
      //   href: `${BASE_PATH}/informationConfiguration`
      // },
      {
        title: '信息配置 / 银行发卡量配置',
        href: `${BASE_PATH}/bankCardIssuance`
      }
    ]
  },
  {
    id: 'VersionReleaseConfig',
    path: 'versionReleaseConfig',
    parentId: 'informationConfiguration',
    name: '版本发布配置',
    element: createLazyElement(async () => await import('@/pages/VersionReleaseConfig')),
    permission: ['OY管理员'],
    breadCrumb: [
      {
        title: '信息配置 / 版本发布配置',
        href: `${BASE_PATH}/versionReleaseConfig`
      }
    ]
  },
  {
    id: 'addArticles',
    path: 'addArticles',
    name: '新增文章',
    menu: false,
    element: createLazyElement(async () => await import('@/pages/ArticlePublished/addArticles'))
  },
  // {
  //   id: 'hotWordConfiguration',
  //   path: 'hotWordConfiguration',
  //   parentId: 'informationConfiguration',
  //   element: createLazyElement(async () => await import('@/pages/HotWordConfiguration')),
  //   name: '热词配置',
  //   breadCrumb: [
  //     {
  //       title: '信息配置',
  //       href: `${BASE_PATH}/informationConfiguration`
  //     },
  //     {
  //       title: '热词配置',
  //       href: `${BASE_PATH}/hotWordConfiguration`
  //     }
  //   ]
  // },
  {
    id: 'articlePublished',
    path: 'articlePublished',
    parentId: 'informationConfiguration',
    element: createLazyElement(async () => await import('@/pages/ArticlePublished')),
    name: '文章发布',
    breadCrumb: [
      // {
      //   title: '信息配置',
      //   href: `${BASE_PATH}/informationConfiguration`
      // },
      {
        title: '信息配置 / 文章发布',
        href: `${BASE_PATH}/articlePublished`
      }
    ]
  },
  {
    id: 'mailInfoConfig',
    path: 'mailInfoConfig',
    parentId: 'informationConfiguration',
    element: createLazyElement(async () => await import('@/pages/MailInfoConfig/index')),
    name: '邮箱信息配置',
    breadCrumb: [
      {
        title: '邮箱信息配置',
        href: `${BASE_PATH}/mailInfoConfig`
      }
    ]
  },
  {
    id: 'addMailInfo',
    path: 'addMailInfo',
    name: '新增邮箱信息',
    menu: false,
    element: createLazyElementWithProps(
      async () => await import('@/pages/MailInfoConfig/addMailInfo'),
      { isEdit: true } // 传递参数
    )
  },
  {
    id: 'operationLog',
    path: 'operationLog',
    element: createLazyElement(async () => await import('@/pages/OperationLog')),
    name: '操作日志',
    icon: <ScheduleOutlined />,
    breadCrumb: [
      {
        title: '操作日志',
        href: `${BASE_PATH}/operationLog`
      }
    ]
  },
  {
    id: 'versionReleaseCenter',
    path: 'versionReleaseCenter',
    name: '版本发布中心',
    icon: <HistoryOutlined />,
    element: createLazyElement(async () => await import('@/pages/VersionReleaseCenter')),
    breadCrumb: [
      {
        title: '版本发布中心',
        href: `${BASE_PATH}/versionReleaseCenter`
      }
    ]
  }
]
